


































import { Vue, Component, Prop } from 'vue-property-decorator'
import { FileInfo, VFS, PathController } from '@/api/types'
import { PageConfig } from '@/store/modules/PageConfigs'
import * as folderIcon from '@/assets/folder.png'
import * as fileIcon from '@/assets/file-icon.png'
import * as filePdfIcon from '@/assets/file-pdf-icon.png'

import Loader from '@/components/Loader.vue'
import filepath from '@/api/filepath'

interface FileInfoWithThumbnail extends FileInfo {
  Thumbnails?: string[];
}

@Component({
  components: { Loader }
})
export default class ExplorerList extends Vue {
  @Prop() files!: FileInfo[]
  @Prop() root!: FileInfo
  @Prop() vfs!: Promise<VFS>
  @Prop() pageConfig!: PageConfig
  @Prop() pathController!: PathController

  private filesWithThumbnail: FileInfoWithThumbnail[] = []
  private isReady = false

  async mounted () {
    this.filesWithThumbnail = await Promise.all(this.files.map(async (f: FileInfo) => {
      const vfs = await this.vfs
      const thumbnails: string[] = []
      const path = this.pathController.resolve(f).path
      if (!f.IsDir) {
        if (f.ContentType === 'application/pdf') {
          thumbnails.push(String(filePdfIcon))
        } else if (f.ContentType === 'video/mp4' || f.ContentType === 'image/png' || f.ContentType === 'image/jpeg' || f.ContentType === 'application/pdf') {
          const filename = await vfs.ResolveFilename(path)
          thumbnails.push(`${filename}.thumbnail`)
        } else {
          thumbnails.push(String(fileIcon))
        }
      } else {
        const children = (await vfs.ReadDir(path)).filter((f: FileInfo) => !f.IsDir).slice(0, 2)
        thumbnails.push(String(folderIcon))
        for (const f in children) {
          const filename = await vfs.ResolveFilename(filepath.join(path, children[f].Name))
          if (children[f].ContentType === 'application/pdf') {
            thumbnails.push(String(filePdfIcon))
          } else if (children[f].ContentType === 'video/mp4' || children[f].ContentType === 'image/png' || children[f].ContentType === 'image/jpeg') {
            thumbnails.push(`${filename}.thumbnail`)
          } else {
            thumbnails.push(String(fileIcon))
          }
        }
      }
      return {
        ...f,
        Thumbnails: thumbnails
      }
    }))

    const scroll = this.$refs.scroller as HTMLElement
    if (scroll) {
      scroll.scrollTop = this.pageConfig.scrollPosition
      scroll.addEventListener('scroll', this.handleScroll)
    }
    this.isReady = true
  }

  handleScroll (event: any) {
    this.$emit('on-scroll', event.target.scrollTop)
  }
}

